
















































































































































































































import Vue from "vue";
import {
  CHANGE_PASSWORD,
  GENERATE_ACCONT_PAYMENT_DETAILS,
  GENERATE_ACCONT_PAYMENT_URL,
  UPDATE_USER,
} from "@/queries/user/mutation.graphql";
import { GET_USER } from "@/queries/user/query.graphql";
import { plans } from "@/mocks/client";
import { apolloClient } from "@/apollo";
export default Vue.extend({
  async beforeRouteEnter(to, from, next) {
    if (to.query["stripe_refresh"]) {
      const {
        data: { generateStripeAccountDetails },
        errors,
      } = await apolloClient.mutate({
        mutation: GENERATE_ACCONT_PAYMENT_URL,
      });
      if (
        generateStripeAccountDetails &&
        generateStripeAccountDetails.accountUrl
      ) {
        const url = generateStripeAccountDetails.accountUrl;
        location.replace(url);
      }
      return;
    }
    next();
    // apolloClient.mutate({
    //   mutation:
    // })
  },
  data() {
    return {
      debounced: null,
      photoUrl: "",
      user: null,
      isOnlinePaymentActive: null,
      loadingOnlinePaymentDetails: false,
      loadingOnlinePaymentURL: false,
      showPassword: false,
      isChangingPass: false,
      password: {
        oldPassword: "",
        newPassword: "",
        confirm: "",
      },
      passwordValidation: {
        oldPassword: "",
        newPassword: "",
        confirm: "",
      },
      plans,
    };
  },
  apollo: {
    user: {
      query: GET_USER,
      update: (data: any) => data.User[0],
    },
  },
  methods: {
    async getOnlinePaymentDetails() {
      this.loadingOnlinePaymentDetails = true;
      const {
        data: { generateStripeAccountDetails },
        errors,
      } = await this.$apollo.mutate({
        mutation: GENERATE_ACCONT_PAYMENT_DETAILS,
      });
      this.loadingOnlinePaymentDetails = false;
      if (generateStripeAccountDetails) {
        if (
          generateStripeAccountDetails.chargesEnabled &&
          generateStripeAccountDetails.detailsSubmitted &&
          generateStripeAccountDetails.payoutsEnabled
        ) {
          this.isOnlinePaymentActive = true;
        } else {
          this.isOnlinePaymentActive = false;
        }
      }
    },
    getOnlinePaymentURL() {
      //code...
    },
    async activateOnlinePayment() {
      this.loadingOnlinePaymentURL = true;
      const {
        data: { generateStripeAccountDetails },
        errors,
      } = await this.$apollo.mutate({
        mutation: GENERATE_ACCONT_PAYMENT_URL,
      });
      this.loadingOnlinePaymentURL = false;
      if (
        generateStripeAccountDetails &&
        generateStripeAccountDetails.accountUrl
      ) {
        const url = generateStripeAccountDetails.accountUrl;
        location.replace(url);
      }
    },
    updatePassword() {
      if (this.password.newPassword !== this.password.confirm) {
        this.$toastr.e("Password doesn't match!", "Error");
        return;
      }
      this.isChangingPass = true;
      const { confirm, ...rest } = this.password;
      this.$apollo
        .mutate({
          mutation: CHANGE_PASSWORD,
          variables: rest,
        })
        .then((data: any) => {
          this.isChangingPass = false;
        })
        .catch((error) => {
          this.isChangingPass = false;
        });
    },
    updateUser() {
      if (this.user.firstName.length === 0 || this.user.lastName.length === 0) {
        return;
      }
      this.$apollo.mutate({
        mutation: UPDATE_USER,
        variables: {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          id: this.user.id,
          photoUrl: this.user.photoUrl,
        },
        update: (cache, { data: { update_User } }) => {
          if (update_User.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_USER,
            });
            data.User[0].firstName = this.user.firstName;
            data.User[0].lastName = this.user.lastName;
          }
        },
      });
    },
    replace(img: string) {
      this.user.photoUrl = img;
      this.updateUser();
    },
    upload(img: string) {
      this.user.photoUrl = img;
      this.updateUser();
    },
    remove() {
      this.user.photoUrl = "";
      this.updateUser();
    },
    submit() {
      //jhkgjh
    },
  },
  created() {
    this.getOnlinePaymentDetails();
  },
  mounted() {
    this.debounced = this.$debounce(this.updateUser, 1500);
  },
});
